import { TableColumnType } from "antd";
import { FilterFilled, PropertySafetyFilled } from '@ant-design/icons';
import { mdlHotel } from "../../models/domain/Hotel";
import { mdlIdNameIndexPair } from "../../models/domain/IdNameIndexPair";
import { mdlBasePaginatedRequest } from "../../models/service-models/common/BasePaginatedRequest";
import { enmSortDirection } from "../../models/enums/SortDirection";

//#region Generic field types.
export const handleTableFilter = (filterValue: any): TableColumnType<any> => ({
    filterIcon: <FilterFilled color="blue" />,
    filterDropdown: filterValue ? (filterDropdownProps) => (<label>{filterValue}</label>) : null,
})

export const handleTableDateFilter = (filterStartDate?: Date, filterEndDate?: Date): TableColumnType<any> => ({
    filterIcon: <FilterFilled color="blue" />,
    filterDropdown: filterStartDate || filterEndDate ? (filterDropdownProps) => (<label>{filterStartDate && new Date(filterStartDate).toLocaleDateString()} - {filterEndDate && new Date(filterEndDate).toLocaleDateString()}</label>) : null,
})

export const handleTableSort = (request?: mdlBasePaginatedRequest, fieldNameInTable?: string): TableColumnType<any> => ({
    sorter: true,
    sortOrder: request?.sortField === fieldNameInTable ? request?.sortDirection === enmSortDirection.Ascending ? "ascend" : "descend" : null,
})

//#endregion
//#region Custom field types.

export const handleTableHotelFilter = (filterHotelGuids?: string[], hotels?: mdlHotel[]): TableColumnType<any> => ({
    filterIcon: <FilterFilled color="blue" />,
    filterDropdown: filterHotelGuids && filterHotelGuids?.length > 0 ? (filterDropdownProps) => (<label>{hotels?.filter(hotel => filterHotelGuids.includes(hotel.id))?.map(hotel => hotel.localName).join(", ")}</label>) : null,
})

export const handleTableAgencyFilter = (filterAgencyGuids?: string[], agencies?: mdlIdNameIndexPair[]): TableColumnType<any> => ({
    filterIcon: <FilterFilled color="blue" />,
    filterDropdown: filterAgencyGuids && filterAgencyGuids?.length > 0 ? (filterDropdownProps) => (<label>{agencies?.filter(agency => filterAgencyGuids.includes(agency.id ?? ""))?.map(agency => agency.name).join(", ")}</label>) : null,
})
// #endregion